import {
  styled,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  alpha,
  Avatar,
} from '@mui/material';

export const ListItemStyled = styled(ListItem)(() => ({
  padding: 4,
}));

export const ListItemButtonStyled = styled(ListItemButton)(({ theme }) => ({
  border: `0.1rem solid ${theme.palette.grey[200]}`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.common.white,
  '&.MuiButtonBase-root': {
    padding: theme.spacing(3),
  },
  '&.Mui-disabled': {
    opacity: 1,
  },
}));

export const ListItemIconDefaultStyled = styled(ListItemIcon)({
  minWidth: 0,
  alignItems: 'center',
});

export const ListItemIconCircleStyled = styled(Avatar)(({ theme }) => ({
  width: 48,
  height: 48,
  padding: theme.spacing(1),
  backgroundColor: alpha(theme.palette.primary.main, 0.1),
}));

export const ListItemTextStyled = styled(ListItemText)({
  margin: 0,
  marginLeft: 15,
});
